export const LANDING_PAGE_FEATURES = [
    {
        id : 'primaryNavMediaRelations',
        label: 'LandingPage.mediaRelations.header',
        upsellMessage: 'LandingPage.mediaRelations.upsellMessage',
        items: [
            {
                id: 'mediaRelationsContacts',
                header: 'LandingPage.mediaRelations.discoverContacts.header',
                message: 'LandingPage.mediaRelations.discoverContacts.message',
                buttonTitle: {
                    provisioned: 'LandingPage.mediaRelations.discoverContacts.buttonTitle.provisioned',
                    notProvisioned: 'LandingPage.productFeatureItem.buttonTitle.notProvisioned'
                },
                headerIcon: 'fa-kit-duotone fa-agpr-discover-contact',
                externalUrl: 'https://help.agilitypr.com/en/articles/11389929-create-a-list-of-media-contacts',
                buttonUrl: {
                    provisioned: 'Discover/targetingsearches/search',
                    notProvisioned: 'https://www.agilitypr.com/contact/'
                }
            },
            {
                id: 'mediaRelationsLists',
                header: 'LandingPage.mediaRelations.targetedLists.header',
                message: 'LandingPage.mediaRelations.targetedLists.message',
                buttonTitle: {
                    provisioned: 'LandingPage.mediaRelations.targetedLists.buttonTitle.provisioned',
                    notProvisioned: 'LandingPage.productFeatureItem.buttonTitle.notProvisioned'
                },
                headerIcon: 'fa-kit-duotone fa-agpr-targeted-list',
                externalUrl: 'https://help.agilitypr.com/en/articles/5535341-how-to-add-to-or-remove-a-contact-from-a-targeted-list',
                buttonUrl: {
                    provisioned: 'Discover/targetinglists',
                    notProvisioned: 'https://www.agilitypr.com/contact/'
                }
            },
            {
                id: 'mediaRelationsInfluencerStreams',
                header: 'LandingPage.mediaRelations.influencersStreams.header',
                message: 'LandingPage.mediaRelations.influencersStreams.message',
                buttonTitle: {
                    provisioned: 'LandingPage.mediaRelations.influencersStreams.buttonTitle.provisioned',
                    notProvisioned: 'LandingPage.productFeatureItem.buttonTitle.notProvisioned'
                },
                headerIcon: 'fa-kit-duotone fa-agpr-influencer-streams',
                externalUrl: 'https://help.agilitypr.com/en/articles/3132994-how-to-use-influencer-streams',
                buttonUrl: {
                    provisioned: 'Discover/influencerstreams',
                    notProvisioned: 'https://www.agilitypr.com/contact/'
                }
            },
            {
                id: 'primaryNavDistributions',
                header: 'LandingPage.mediaRelations.emailDistributions.header',
                message: 'LandingPage.mediaRelations.emailDistributions.message',
                buttonTitle: {
                    provisioned: 'LandingPage.mediaRelations.emailDistributions.buttonTitle.provisioned',
                    notProvisioned: 'LandingPage.productFeatureItem.buttonTitle.notProvisioned'
                },
                headerIcon: 'fa-kit-duotone fa-agpr-distribution',
                externalUrl: 'https://help.agilitypr.com/en/articles/11393938-send-your-press-releases-media-pitches-using-email-distributions',
                buttonUrl: {
                    provisioned: 'Discover/distributions',
                    notProvisioned: 'https://www.agilitypr.com/contact/'
                }
            },
            {
                id: 'primaryNavNewsroom',
                header: 'LandingPage.mediaRelations.newsroom.header',
                message: 'LandingPage.mediaRelations.newsroom.message',
                buttonTitle: {
                    provisioned: 'LandingPage.mediaRelations.newsroom.buttonTitle.provisioned',
                    notProvisioned: 'LandingPage.productFeatureItem.buttonTitle.notProvisioned'
                },
                headerIcon: 'fa-duotone fa-regular fa-bullhorn',
                externalUrl: 'http://help.agilitypr.com/en/articles/2984179-post-your-content-to-the-agility-newsroom',
                buttonUrl: {
                    provisioned: 'Newsroom',
                    notProvisioned: 'https://www.agilitypr.com/contact/'
                }
            },
            {
                id: 'primaryNavNewswire',
                header: 'LandingPage.mediaRelations.newswire.header',
                message: 'LandingPage.mediaRelations.newswire.message',
                buttonTitle: {
                    provisioned: 'LandingPage.mediaRelations.newswire.buttonTitle.provisioned',
                    notProvisioned: 'LandingPage.productFeatureItem.buttonTitle.notProvisioned'
                },
                headerIcon: 'fa-duotone fa-regular fa-globe',
                externalUrl: 'https://help.agilitypr.com/en/articles/6319715-how-to-submit-newswires-using-agility',
                buttonUrl: {
                    provisioned: 'Amplify/wires',
                    notProvisioned: 'https://www.agilitypr.com/contact/'
                }
            }
        ]
    },
    {
        id: 'primaryNavMediaIntelligence',
        label: 'LandingPage.mediaMonitoring.header',
        upsellMessage: 'LandingPage.mediaMonitoring.upsellMessage',
        items: [
            {
                id: 'primaryNavSearch',
                header: 'LandingPage.mediaMonitoring.monitoringSearch.header',
                message: 'LandingPage.mediaMonitoring.monitoringSearch.message',
                buttonTitle: {
                    provisioned: 'LandingPage.mediaMonitoring.monitoringSearch.buttonTitle.provisioned',
                    notProvisioned: 'LandingPage.productFeatureItem.buttonTitle.notProvisioned'
                },
                headerIcon: 'fa-duotone fa-regular fa-file-magnifying-glass',
                externalUrl: 'https://help.agilitypr.com/en/articles/3084667-create-monitoring-topics-to-discover-and-analyse-your-media-coverage',
                buttonUrl: {
                    provisioned: 'Monitoring/search',
                    notProvisioned: 'https://www.agilitypr.com/contact/'
                }
            },
            {
                id: 'primaryNavMentions',
                header: 'LandingPage.mediaMonitoring.savedCoverage.header',
                message: 'LandingPage.mediaMonitoring.savedCoverage.message',
                buttonTitle: {
                    provisioned: 'LandingPage.mediaMonitoring.savedCoverage.buttonTitle.provisioned',
                    notProvisioned: 'LandingPage.productFeatureItem.buttonTitle.notProvisioned'
                },
                headerIcon: 'fa-kit-duotone fa-agpr-folders',
                externalUrl: 'https://help.agilitypr.com/en/articles/3577400-organise-your-mentions-with-folders-and-tags-and-tag-groups',
                buttonUrl: {
                    provisioned: 'Monitoring/mentions',
                    notProvisioned: 'https://www.agilitypr.com/contact/'
                }
            },
            {
                id: 'primaryNavBriefings',
                header: 'LandingPage.mediaMonitoring.briefings.header',
                message: 'LandingPage.mediaMonitoring.briefings.message',
                buttonTitle: {
                    provisioned: 'LandingPage.mediaMonitoring.briefings.buttonTitle.provisioned',
                    notProvisioned: 'LandingPage.productFeatureItem.buttonTitle.notProvisioned'
                },
                headerIcon: 'fa-kit-duotone fa-agpr-briefings',
                externalUrl: 'https://help.agilitypr.com/en/articles/3142693-how-to-create-an-automated-briefing',
                buttonUrl: {
                    provisioned: 'Monitoring/briefings',
                    notProvisioned: 'https://www.agilitypr.com/contact/'
                }
            },
            {
                id: 'primaryNavAlerts',
                header: 'LandingPage.mediaMonitoring.coverageAlerts.header',
                message: 'LandingPage.mediaMonitoring.coverageAlerts.message',
                buttonTitle: {
                    provisioned: 'LandingPage.mediaMonitoring.coverageAlerts.buttonTitle.provisioned',
                    notProvisioned: 'LandingPage.productFeatureItem.buttonTitle.notProvisioned'
                },
                headerIcon: 'fa-duotone fa-regular fa-bell-exclamation',
                externalUrl: 'https://help.agilitypr.com/en/articles/12116654-create-coverage-alerts-and-surge-alerts',
                buttonUrl: {
                    provisioned: 'Monitoring/alerts',
                    notProvisioned: 'https://www.agilitypr.com/contact/'
                }
            },
            {
                id: 'primaryNavSubscriptions',
                header: 'LandingPage.mediaMonitoring.subscriptions.header',
                message: 'LandingPage.mediaMonitoring.subscriptions.message',
                buttonTitle: {
                    provisioned: 'LandingPage.mediaMonitoring.subscriptions.buttonTitle.provisioned',
                    notProvisioned: 'LandingPage.productFeatureItem.buttonTitle.notProvisioned'
                },
                headerIcon: 'fa-duotone fa-regular fa-envelope-open-text',
                externalUrl: 'https://help.agilitypr.com/en/articles/4842435-monitoring-tv-and-radio-using-subscriptions-and-saving-broadcast-media-mentions',
                buttonUrl: {
                    provisioned: 'Monitoring/subscriptions',
                    notProvisioned: 'https://www.agilitypr.com/contact/'
                }
            },
            {
                id: 'primaryNavReports',
                header: 'LandingPage.mediaMonitoring.customReports.header',
                message: 'LandingPage.mediaMonitoring.customReports.message',
                buttonTitle: {
                    provisioned: 'LandingPage.mediaMonitoring.customReports.buttonTitle.provisioned',
                    notProvisioned: 'LandingPage.productFeatureItem.buttonTitle.notProvisioned'
                },
                headerIcon: 'fa-kit-duotone fa-agpr-reports',
                externalUrl: 'https://help.agilitypr.com/en/articles/3147788-create-a-monitoring-report-based-on-your-topic-results-and-saved-coverage',
                buttonUrl: {
                    provisioned: 'Report/reports',
                    notProvisioned: 'https://www.agilitypr.com/contact/'
                }
            }
        ]
    },
    {
        id: 'primaryNavSocial',
        label: 'LandingPage.social.header',
        upsellMessage: 'LandingPage.social.upsellMessage',
        items: [
            {
                id: 'primaryNavSocialListening',
                header: 'LandingPage.social.socialListing.header',
                message: 'LandingPage.social.socialListing.message',
                buttonTitle: {
                    provisioned: 'LandingPage.social.socialListing.buttonTitle.provisioned',
                    notProvisioned: 'LandingPage.productFeatureItem.buttonTitle.notProvisioned'
                },
                headerIcon: 'fa-kit-duotone fa-agpr-social',
                externalUrl: 'https://help.agilitypr.com/en/articles/6312469-how-to-use-social-listening',
                buttonUrl: {
                    provisioned: 'Social',
                    notProvisioned: 'https://www.agilitypr.com/contact/'
                }
            }
        ]
    }
];

export const NAVBAR_IDS = {
    MEDIA_RELATIONS: 'primaryNavMediaRelations',
    MEDIA_INTELLIGENCE: 'primaryNavMediaIntelligence',
    SOCIAL: 'primaryNavSocial',

    DISTRIBUTIONS: 'primaryNavDistributions',
    TARGETED_LISTS: 'mediaRelationsLists',
    SAVED_SEARCHES: 'mediaRelationsSavedSearches',
    TOPICS: 'primaryNavTopics',
    MENTIONS: 'primaryNavMentions',
    BRIEFINGS: 'primaryNavBriefings',
    REPORTS: 'primaryNavReports',
    SOCIAL_LISTENING: 'primaryNavSocialListening',
    ALERTS: 'primaryNavAlerts',
};
